import React from "react";
import { Card, CardHeader,Input, Container, Button, Table, Row } from "reactstrap";
import { useState } from "react"
import { failureToast} from '../../common/utils/methods/toasterFunctions/function'
import {TDROW ,MasterHeader } from "../../common/commonComponents/masterRow/masterRow";
import { masterServiceBaseUrl, successToast, putpost, putpost2 } from 'services/http'
import moment from 'moment';

var _ = require('lodash');
  
const AesIdTypeTable = (props) => {
  const [isSaveVisible, setisSaveVisible] = useState(false)
  const [tableDataKey, settableDataKey] = useState('tableDataKey')
  const addNewClass = () =>{
    props.setclassArray([{"editMode":true,"__status":"__new","aesIdTypeKey":null,'status':'ACTIVE',"aesIdTypeDesc": null,"aesIdTypeDispValue": null, "effectiveDate": null },...props.classArray])
  }
  const saveAll = (cb) =>{
    var _tempArray = props.classArray
    var isValid = true
    _tempArray.forEach((el,index)=>{
      if(el['editMode']){
        if(el['aesIdTypeKey']==null||!el['aesIdTypeKey'].trim()){
          isValid= false
          failureToast('Please enter the value of Access Code Key')
          return
        }else if(el['aesIdTypeDesc']==null||!el['aesIdTypeDesc'].trim()){
          isValid= false
          failureToast('Please enter the value of Access Code Description')
          return
        }
        else if(el['aesIdTypeDispValue']==null||!el['aesIdTypeDispValue'].trim()){
            isValid= false
            failureToast('Please enter the value of Access Code Display Value')
            return
          }
            if(!isValid){
              return
            }
          if (_tempArray[index]['__status'] == "__new") {
            putpost(masterServiceBaseUrl + '/aesIdType/createAESIdType', (data) => {
              successToast(data['message'])
              setisSaveVisible(false)
              props.fetchClasses(masterServiceBaseUrl + '/aesIdType/getAllAESIdType')
            }, (data) => { failureToast(data['message']) }, _tempArray[index], 'post')
          } else {
            putpost(masterServiceBaseUrl + '/aesIdType/updateAESIdType/' + _tempArray[index].id, (data) => {
              successToast(data['message'])
              setisSaveVisible(false)
              delete _tempArray[index]['editMode']
              props.setclassArray(_tempArray)
              settableDataKey(new Date().getMilliseconds())
              // props.fetchClasses(masterServiceBaseUrl + '/class/getAllClass')
            }, (data) => { failureToast(data['message']) }, _tempArray[index], 'put')
          }
        } else {
  
        }
      })
  }
  const newRow = () => {
    if (isSaveVisible) {
      failureToast("Please Delete or Save current changes")
    }
    else {
      let cb = () => {
        addNewClass()
        setisSaveVisible(true)
        // settableDataKey(new Date().getMilliseconds())
      }
      var _tempArray = props.classArray
      _tempArray = _.sortBy(_tempArray, [function (o) { return o.value; }])
      props.setclassArray(_tempArray)
      setisSaveVisible(false)
      cb()
    }
  }
  const editRow = (index)=>{
    if (isSaveVisible) {
      failureToast("Please Delete or Save current changes")
    }
    else {
      let cb = () => {
        var _tempArray = props.classArray
        _tempArray[index]['editMode'] = true
        props.setclassArray(_tempArray)
        setisSaveVisible(true)
      }
      var _tempArray = props.classArray
      _tempArray = _.sortBy(_tempArray, [function (o) { return o.value; }])
      cb()
    }
  }
  const deleteRow = (index) => {
    if (props.classArray[index]["__status"] == "__new") {
      let n = props.classArray
      n.splice(index, 1)
      props.setclassArray(n)
      setisSaveVisible(false)
      settableDataKey(new Date().getMilliseconds())
    } else {
      if (window.confirm('Are you sure you want to delete this Access Code?')) {
        putpost2(masterServiceBaseUrl + '/aesIdType/deleteAESIdType/' + props.classArray[index].id, (data) => {
          successToast(data['message'])
          if (props.classArray.length == 1) {
            props.previousPage()
            props.fetchClasses(masterServiceBaseUrl + '/aesIdType/getAllAESIdType')
          } else {
            var _tempArray = props.classArray
            if (_tempArray[index]['editMode']) {
              setisSaveVisible(false)
            }
            _tempArray.splice(index, 1)
            props.setclassArray(_tempArray)
          }
          settableDataKey(new Date().getMilliseconds())
        }, (data) => { failureToast(data['message']) }, 'PUT')
      }
    }
  }
  const updateKey = (index,value,key)=>{
    var _tempArray = props.classArray
    _tempArray[index][key] = value
    props.setclassArray(_tempArray)
  }
  return (
    <>
      <Container className="mt-3" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardHeader className="border-0">
                <h3 className="mb-0 floatLeft">Master - Access Code</h3>
                <Button disabled={isSaveVisible}  color="info" size="sm" type="button" className={"floatRight mx-1"+(isSaveVisible?" btn-dark":null)} onClick={() => {newRow()}}>New Access Code</Button>
                {/* {isSaveVisible?<Button color="info" size="sm" type="button" className="floatRight mx-1" onClick={() => {saveAll()}}>Save</Button>:null} */}
              </CardHeader>
              <div id="questionTable" className="table-responsive">
                <Table className="align-items-center table-flush tableLayout" >
                  <MasterHeader type={"Access Code"} />
                  <tbody className="list" key={tableDataKey} >
                    {props.classArray ? props.classArray.map((el, index) => 
                    !el['editMode']?(
                      <TDROW type={"aesIdType"} index={index} el={el} editRow={editRow} deleteRow={deleteRow} />
                    ):
                    (<tr key={index+'-class'}>
                      <td className="text-center p-2 mx-1"><Input maxLength={50} defaultValue={el['aesIdTypeKey']} onChange={(e)=>{updateKey(index,e.target.value,'aesIdTypeKey')}} placeholder="Access Code Key" className="tdInput" /></td>
                      <td className="text-center p-2 mx-1"><Input disabled={true} defaultValue={el["__status"] == "__new" ? null : moment(el['effectiveDate']).format('DD-MM-YYYY')} placeholder="Effective Date" className="tdInput" /></td>
                      <td className="text-center p-2 mx-1"><Input maxLength={50} defaultValue={el['aesIdTypeDesc']} onChange={(e)=>{updateKey(index,e.target.value,'aesIdTypeDesc')}} placeholder="Access Code Description" className="tdInput" /></td>
                      <td className="text-center p-2 mx-1"><Input maxLength={50} defaultValue={el['aesIdTypeDispValue']} onChange={(e)=>{updateKey(index,e.target.value,'aesIdTypeDispValue')}} placeholder="Access Code Display Value" className="tdInput" /></td>
                      <td className="text-center p-2 mx-1">
                      <label className="custom-toggle mx-auto ml-2">
                      <input checked={el.status == "ACTIVE" ? true : false} type="checkbox" id={el.id} onChange={(e) => { settableDataKey(new Date().getMilliseconds()); let n = "ACTIVE"; if (!e.target.checked) { n = "INACTIVE" } updateKey(index, n, 'status') }} />
                          <span style={{width:"72px"}} className="custom-toggle-slider rounded-circle activeToggle" data-label-off="Inactive" data-label-on="Active" />
                          </label>
                      </td>
                      <td className="text-center">
                        {/* <Button color="info" size="sm" type="button" onClick={() => {
                          deleteRow(index)
                        }}>  <i className="fas fa-trash" /></Button> */}
                         {isSaveVisible ? <> <Button color="info" size="sm" type="button" className="mx-1" onClick={() => { saveAll() }}>Save</Button>
                            <Button color="danger" size="sm" type="button" onClick={() => {
                              let n=props.classArray
                              if(n[index]['__status']=='__new'){
                                n.splice(index,1)
                              }else{
                              // n[index]['editMode']=false
                              props.fetchClasses(masterServiceBaseUrl+'/aesIdType/getAllAESIdType')
                              }
                              props.setclassArray(n)
                              setisSaveVisible(false)
                            }}>  <i className="fas fa-times" /></Button> </>:
                              <Button color="info" size="sm" type="button" onClick={() => {
                                deleteRow(index)
                              }}>  <i className="fas fa-trash" /></Button>}
                      </td>
                    </tr>)
                    ) : null}
                  </tbody>
                </Table>
              </div>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  )
}
export default AesIdTypeTable;
